import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import WebService from "../../../../../utility/WebService";
import { useNavigate } from "react-router-dom";
import Grid, { GridColumn, GridHeader, GridRow } from "../../../../../components/Grid/Grid";
import AlertModal from "../../../../../components/AlertComponent/Alert";
import WarningModal from "../../../../../components/Warning/Warning";
import SucessModal from "../../../../../components/SucessModal/Sucess";
import { BsQuestionCircle } from "react-icons/bs";

const headers: GridHeader[] = [
  {
    title: "Product Category",
    classTitle: "text-start"
  },
  {
    title: "Company",
    class: "text-center"
  },
  {
    title: "Product Name",
    class: "text-center"
  },
  {
    title: "Locking Period By Income Tax",
    class: "text-center"
  },
  {
    title: "Locking Period By Vendor",
    class: "text-center"
  },
  {
    title: "Actions",
    class: "text-center"
  },
];

const FixedReturnandRetirementProducts = () => {
  const [rows, setRows] = useState<GridRow[]>([]);
  const [ShowLoader, setShowLoader] = useState(false);
  const [totalCount, setTotalCount] = useState("");
  const [isShoWDeleteModal, setShowDeleteModal] = useState(false);
  const [deletedData, setDeletedData] = useState<any>({});
  const [warningMessage, setWarningMessage] = useState<any>()
  const [isShowWarningModal, setShowWarningModal] = useState(false);
  const [sucessMessage, setSucessMessage] = useState<any>()
  const [isShowSucessModal, setShowSucessModal] = useState(false);
  let history = useNavigate();

  useEffect(() => {
    getList(1, "");
  }, []);

  const getList = (page?: any, searchText?: string) => {
    setShowLoader(true);
    WebService.postAPI({
      action: `/v2/CommonProductParameters/List?page=${page}&keyword=${searchText}`,
    })
      .then((res: any) => {
        setTotalCount(res.total_count);
        setShowLoader(false);
        let rows: GridRow[] = [];
        for (var i in res.list) {
          let columns: GridColumn[] = [];
          columns.push({ value: res.list[i].issuer_category ? res.list[i].issuer_category : "-" });
          columns.push({ value: res.list[i].company_name ? res.list[i].company_name : "-" });
          columns.push({ value: res.list[i].product_name ? res.list[i].product_name : "-" });
          columns.push({ value: res.list[i].locking_period_by_income_tax ? res.list[i].locking_period_by_income_tax : "-" });
          columns.push({ value: res.list[i].locking_period_by_vendor ? res.list[i].locking_period_by_vendor : "-" });
          columns.push({ value: actionList(res.list[i].common_product_parameters_id), });
          rows.push({ data: columns });
        }
        setRows(rows);
      })
      .catch(() => {
        setShowLoader(false);
      });
  };

  const actionList = (value: any) => {
    return (
      <div>
        <a onClick={() => history(`/Product-parameters/edit-fixed-return-and-retirement-products/${value}`)} title="Edit">
          <svg
            className="icon inline mr-2 cursor-pointer"
            width={18}
            height={18}
          >
            <use xlinkHref="/images/svg-sprint/common-icon-sprint.svg#edit"></use>
          </svg>
          &nbsp; &nbsp;&nbsp;
        </a>
        <a onClick={() => onDelete(value)} title="Delete">
          <svg className="icon inline cursor-pointer" width={20} height={20}>
            <use xlinkHref="/images/svg-sprint/common-icon-sprint.svg#delete"></use>
          </svg>
        </a>
      </div>
    );
  };

  const onDelete = (data: any) => {
    setShowDeleteModal(true);
    var obj = {
      id: data,
    };
    setDeletedData(obj);
  };

  const deletedFixedReturnandRetirementProducts = () => {
    setShowDeleteModal(false);
    WebService.postAPI({
      action: `/v2/CommonProductParameters/Delete?id=${deletedData["id"]}`,
      body: null,
    })
      .then((res: any) => {
        setShowSucessModal(true);
        setSucessMessage(res.message)
        getList(1, "");
      })
      .catch((e) => {
        setShowWarningModal(true);
        setWarningMessage(e.response.data.message)
      });
  };

  const closeModal = () => {
    setShowDeleteModal(false);
  };

  const onSorting = (currentPage: number, searchText: string) => {
    getList(currentPage, searchText);
  };

  const warningCloseModal = () => {
    setShowWarningModal(false)
    setShowLoader(false);
  }

  const sucessCloseModal = () => {
    setShowSucessModal(false)
    setShowLoader(false);
  }

  return (
    <>
      <SucessModal
        show={isShowSucessModal}
        isClose={sucessCloseModal}
        message={sucessMessage}
      />
      <WarningModal
        show={isShowWarningModal}
        isClose={warningCloseModal}
        message={warningMessage}
      />

      <AlertModal
        show={isShoWDeleteModal}
        isClose={closeModal}
        delete={deletedFixedReturnandRetirementProducts}
        data={deletedData}
      />

      <div className="page-content-wraper">
        <div className="grid grid-cols-2 gap-4 mb-3">
          <div>
            <h1 className="page-title">Fixed Return & Retirement Products</h1>
          </div>
          <div className="text-right flex justify-end items-center">
            <button type="button" className="btn bg-white px-3 py-1 rounded-md hover:shadow-xl shadow-sm mr-3" title="Help">
              <BsQuestionCircle size={20} className="inline mr-1" /> Help
            </button>
            <button type="button" className="btn bg-white px-3 py-1 rounded-md hover:shadow-xl shadow-sm mr-3" title="Archive" onClick={() => history(`/Product-parameters/archived-fixed-return-and-retirement-products`)} >
              <svg className="icon inline mr-2 inline" width={20} height={20} >
                <use xlinkHref="/images/svg-sprint/common-icon-sprint.svg#archivedIcon"></use>
              </svg> Archived
            </button>
            <NavLink to="/Product-parameters/add-fixed-return-and-retirement-products" className="btn btn-brand btn-sm">
              + Add
            </NavLink>
          </div>
        </div>
        <div className="table-card">
          <Grid
            headers={headers}
            rows={rows}
            ShowLoader={ShowLoader}
            errorMessage={"No Fixed Return and Retirement Products Found"}
            count={totalCount}
            onPageChange={onSorting}
            isShowSearch={true}
          />
        </div>
      </div>
    </>
  );
};
export default FixedReturnandRetirementProducts;
